module.exports = __webpack_public_path__ + "static/media/loginVideo.81c90fb6.svg";